import React, { useEffect, useState } from "react";
import {
  BackButton,
  Box,
  ButtonStyled,
  FormElementWrapper,
  NotAuthorizedForResource,
  SpanStyled,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../../../components/styled/Elements";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ProfileWrapper } from "./styled";
import {
  MenuTriggerCross,
  PlaceholderImg,
  Plus,
  SingleProfile,
} from "../../../../../components/styled/AllImages";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import FormRadio from "../../../../../components/common/radioButtons/FormRadio";
import Breadcrumbs from "../../../../../components/admin/Breadcrumbs/Breadcrumbs";
import { useForm } from "react-hook-form";
import CabinetsApi from "../../../../../services/api/cabinetsApi";
import { toast } from "react-toastify";
import { ContentWrapper } from "../../../../../components/styled/styled";
import ValidatedInput from "../../../../../components/common/inputFields/ValidatedInput";
import ValidationController from "../../../../../components/common/inputFields/ValidationController";
import ValidationErrorText from "../../../../../components/common/inputFields/ValidationErrorText";
import AddSingleDepartment from "../../../../../components/common/modals/singleDepartmentModal/AddSingleDepartment";
import AddMultipleDepartments from "../../../../../components/common/modals/multipleDepartmentsModal/AddMultipleDepartments";
import AddMultipleUsers from "../../../../../components/common/modals/multipleUsersModal/AddMultipleUsers";
import { useSelector } from "react-redux";
import RequestsApi from "../../../../../services/api/requestsApi";
import { getIsTemporary } from "../../../../../utils";
import AddMultipleUsersBranchDep from "../../components/AddMultiUsersBranchDep";

const ASSET_URL = process.env.REACT_APP_ASSET_URL;

const EditTemporaryFile = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { usersList, branchesDeps, hqBranchesList } = useSelector(
    (state) => state.helper
  );
  const navigate = useNavigate();
  // const location = useLocation();
  // const isTemporary = location.state?.is_temporary;

  const isTemporary = 1;
  const { id, fileId } = useParams();
  const [accessDenied, setAccessDenied] = useState(false);
  const [initFileId, setInitFileId] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [accessThroughRequest, setAccessThroughRequest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState(null);
  const [radioOptions, setRadioOptions] = useState([]);
  const [userSelections, setUserSelections] = useState({
    branch_ids: [],
    department_ids: [],
    user_ids: [],
  });
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [checkedHqBranches, setCheckedHqBranches] = useState({});

  const {
    register,
    handleSubmit,
    watch,
    reset,
    resetField,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      selected_ids: selectedIds,
    },
  });
  const checkSelectedValueID = watch("common_settings_id");

  const handleSingleSelect = (id) => {
    if (id) {
      setSelectedIds([id]);
    } else {
      setSelectedIds([]);
    }
  };

  const validateSelection = (value) => {
    if (
      [4, 5, 8, 9].includes(Number(checkSelectedValueID)) &&
      (!value || value.length === 0)
    ) {
      return t("Please_select_user");
    }
    if ([6, 7].includes(Number(checkSelectedValueID)) && !value) {
      return t("Please_select_department");
    }
    return true;
  };

  const handleRemoveRequest = async (id) => {
    try {
      const { code, message } = await RequestsApi.removeRequest({ id });
      if (code === 200) {
        setAccessThroughRequest(
          accessThroughRequest.filter((item) => item.id != id)
        );
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };

  const getCabinetSingleFile = async () => {
    try {
      setAccessDenied(false);
      setLoading(true);
      const response = await CabinetsApi.getCabinetSingleFile(id, fileId);
      if (response?.data) {
        const formattedCheckedUsers =
          response?.data?.file?.cabinetfile_detail?.selected_users_data?.map(
            (item) => ({
              ...item,
              subLabel:
                language === "en"
                  ? `${item?.user_detail?.department_selective?.name_en} (${item?.user_detail?.office_location_selective?.name_en})`
                  : `${item?.user_detail?.department_selective?.name_ar} (${item?.user_detail?.office_location_selective?.name_ar})`,
            })
          );
        setCheckedUsers(formattedCheckedUsers);
        const from_branches =
            response?.data?.file?.cabinetfile_detail?.from_branches || [];
          const from_departments =
            response?.data?.file?.cabinetfile_detail?.from_departments || [];

          setCheckedHqBranches({
            branchIds: from_branches,
            depIds: from_departments,
          });
        reset({
          id: response?.data?.file?.id,
          name: response?.data?.file?.name || "",
          description: response?.data?.file?.description || "",
          common_settings_id: response?.data?.file?.common_settings_id || "",
          is_temporary: response?.data?.file?.is_temporary,
          selected_ids:
            response?.data?.file?.common_settings_id === 4 ||
            response?.data?.file?.common_settings_id === 5
              ? response?.data?.file?.cabinetfile_detail?.selected_users
              : response?.data?.file?.cabinetfile_detail?.selected_departments,
        });
        setInitFileId(response?.data?.file?.id);

        setFilteredUsers(
          usersList?.filter(
            (usr) =>
              usr?.user_detail?.department_id ==
              response?.data?.file?.current_owner_department_id
          )
        );
        setAccessThroughRequest(
          response?.data?.file?.access_granted_requests.map((item) => ({
            ...item,
            profile: item?.from_user?.profile
              ? `${ASSET_URL}}/${item?.from_user?.profile}`
              : null,
          }))
        );

        setSelectedIds(
          response?.data?.file?.common_settings_id === 4 ||
            response?.data?.file?.common_settings_id === 5
            ? response.data.file.cabinetfile_detail?.selected_users
            : response.data.file.cabinetfile_detail?.selected_departments
        );
      }
      if (response?.code === 403) {
        setAccessDenied(true);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getRadioData = async () => {
    try {
      setDataLoading(true);
      const response = await CabinetsApi.addCabinetRadio();

      if (response?.data?.length > 0) {
        const filteredOptions = response?.data;

        setRadioOptions([
          ...filteredOptions.map((option) => {
            if (option.id == 7 || option.id == 8) {
              return { ...option, description: "" };
            } else if (option.id == 6) {
              return {
                ...option,
                description: t("only_open_to_one_department_description"),
              };
            } else if (
              option.id == 2 ||
              option.id == 3 ||
              option.id == 4 ||
              option.id == 5
            ) {
              return {
                ...option,
                description: t("file_settings_description"),
              };
            } else if (option.id == 1) {
              return {
                ...option,
                title: t("based_on_cabinet_setting"),
                description: t("based_on_cabinet_setting_description"),
              };
            }
            return option;
          }),
        ]);
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    getRadioData();
  }, [language]);

  useEffect(() => {
    if (id && radioOptions.length > 0) {
      getCabinetSingleFile(id, fileId);
    }
  }, [id, fileId, radioOptions]);
  const onSubmit = async (formData) => {
    const updatedData = {
      ...formData,
      file_id: initFileId,
      action: "update",
      selected_ids: selectedIds,
      is_temporary: isTemporary && isTemporary,
      from_branches: userSelections.branch_ids,
      from_departments: userSelections.department_ids,
    };

    try {
      setSubmitLoading(true);
      const response = await CabinetsApi.createCabinetFile(id, updatedData);
      if (response.code === 200) {
        toast.success(t("file_updated"));
        reset();
        navigate(`/temporary-cabinets/${id}/temporary-files`);
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setSubmitLoading(false);
    }
  };
  

  return (
    <ProfileWrapper>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="content-head">
          <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
            <BackButton
              label={t("edit_temporary_file")}
              onClick={() => navigate(`/temporary-cabinets/${id}/temporary-files`)}
            />
            <Breadcrumbs />
          </Box>
        </Box>
        {accessDenied ? (
          <NotAuthorizedForResource />
        ) : (
          <ContentWrapper>
            {dataLoading || loading ? (
              <ThemeLoader />
            ) : (
              <>
                <Box>
                  <ValidatedInput
                    name="name"
                    type="input"
                    fieldType="text"
                    placeholder={"FileName"}
                    label="FileName"
                    staric={true}
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                    className={"border-0"}
                  />
                  <ValidatedInput
                    name="description"
                    label="Description"
                    type="textarea"
                    placeholder={"Description"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: false,
                    }}
                  />
                </Box>

                <Box>
                  {!isTemporary && (
                    <>
                      <SubHeadingStyled
                        size="18px"
                        weight={700}
                        color={"var(--text)"}
                        className="px-4 pt-4 pb-0"
                      >
                        {t("file_access_settings")}
                      </SubHeadingStyled>
                      <Box className="optionsWrapper">
                        <Box className="">
                          {radioOptions?.slice(0, 1)?.map((x, i) => (
                            <Box
                              key={i}
                              className={`w-100 p-2 ${
                                i !== radioOptions.length - 1 &&
                                "separation-border"
                              }`}
                            >
                              <FormRadio
                                name="common_settings_id"
                                label={t(x.title)}
                                subLabel={t(x.description)}
                                value={x.id}
                                register={register}
                                checked={
                                  parseInt(checkSelectedValueID) == x?.id
                                }
                                validationRules={{
                                  required: true,
                                }}
                                onClick={() => {
                                  setSelectedIds(null);
                                  resetField("selected_ids");
                                }}
                              />
                            </Box>
                          ))}
                          <Box className="px-4">
                            {errors.common_settings_id?.type === "required" && (
                              <ValidationErrorText
                                text={
                                  t(errors.common_settings_id?.message) ||
                                  t("Pleaseselectone")
                                }
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                      {/* Phase 2 */}
                      <Box className="optionsWrapper">
                        <Box className="optionsContent">
                          <SubHeadingStyled
                            size="15px"
                            weight={700}
                            color={"var(--text)"}
                            className="px-4 pt-4 pb-0"
                          >
                            {t("my_department")}
                          </SubHeadingStyled>
                          {radioOptions?.slice(1, 5)?.map((x, i) => (
                            <Box
                              key={i}
                              className={`w-100 p-2 ${
                                i !== radioOptions.length - 1 &&
                                "separation-border"
                              }`}
                            >
                              <FormRadio
                                name="common_settings_id"
                                label={t(x.title)}
                                // subLabel={t(x.description)}
                                value={x.id}
                                register={register}
                                checked={
                                  parseInt(checkSelectedValueID) == x?.id
                                }
                                validationRules={{
                                  required: true,
                                }}
                                onClick={() => {
                                  setSelectedIds(null);
                                  resetField("selected_ids");
                                }}
                              />
                              {checkSelectedValueID == 4 &&
                                x.id == checkSelectedValueID && (
                                  <Box className="addUserCont">
                                    <ValidationController
                                      name="selected_ids"
                                      validationConfig={{
                                        validate: validateSelection,
                                      }}
                                      errors={errors}
                                      control={control}
                                      renderer={({ field }) => (
                                        <AddMultipleUsers
                                          title="add_users"
                                          icon={<SingleProfile />}
                                          selPlaceholder="SelectUser"
                                          mainParents={filteredUsers}
                                          setSelectedIds={(ids) => {
                                            field.onChange(ids);
                                            setSelectedIds(ids);
                                          }}
                                          selectedIds={selectedIds}
                                        />
                                      )}
                                    />
                                  </Box>
                                )}
                              {checkSelectedValueID == 5 &&
                                x.id == checkSelectedValueID && (
                                  <Box className="addUserCont">
                                    <ValidationController
                                      name="selected_ids"
                                      validationConfig={{
                                        validate: validateSelection,
                                      }}
                                      errors={errors}
                                      control={control}
                                      renderer={({ field }) => (
                                        <AddMultipleUsers
                                          title="add_users"
                                          icon={<SingleProfile />}
                                          selPlaceholder="SelectUser"
                                          mainParents={filteredUsers}
                                          setSelectedIds={(ids) => {
                                            field.onChange(ids);
                                            setSelectedIds(ids);
                                          }}
                                          selectedIds={selectedIds}
                                        />
                                      )}
                                    />
                                  </Box>
                                )}
                            </Box>
                          ))}
                          <Box className="px-4">
                            {errors.common_settings_id?.type === "required" && (
                              <ValidationErrorText
                                text={
                                  t(errors.common_settings_id?.message) ||
                                  t("Pleaseselectone")
                                }
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                      {/* Phase 3 */}
                      <Box className="optionsWrapper">
                        <Box className="optionsContent">
                          <SubHeadingStyled
                            size="15px"
                            weight={700}
                            color={"var(--text)"}
                            className="px-4 pt-4 pb-0"
                          >
                            {t("other_departments")}
                          </SubHeadingStyled>
                          {radioOptions?.slice(5, 9)?.map((x, i) => (
                            <Box
                              key={i}
                              className={`w-100 p-2 ${
                                i !== radioOptions.length - 1 &&
                                "separation-border"
                              }`}
                            >
                              <FormRadio
                                name="common_settings_id"
                                label={t(x.title)}
                                // subLabel={t(x.description)}
                                value={x.id}
                                register={register}
                                checked={
                                  parseInt(checkSelectedValueID) == x?.id
                                }
                                validationRules={{
                                  required: true,
                                }}
                                onClick={() => {
                                  setSelectedIds(null);
                                  resetField("selected_ids");
                                }}
                              />

                              {checkSelectedValueID == 6 &&
                                x.id == checkSelectedValueID && (
                                  <Box className="addUserCont">
                                    <ValidationController
                                      name="selected_ids" // Field name for validation
                                      validationConfig={{
                                        validate: validateSelection,
                                      }}
                                      errors={errors}
                                      control={control}
                                      renderer={({ field }) => (
                                        <AddSingleDepartment
                                          title="select_department"
                                          icon={<Plus />}
                                          selPlaceholder="Select_One_Department"
                                          mainParents={branchesDeps}
                                          setSelectedItem={(ids) => {
                                            field.onChange(ids);
                                            setSelectedIds(ids);
                                          }}
                                          selectedItem={selectedIds}
                                        />
                                      )}
                                    />
                                  </Box>
                                )}
                              {checkSelectedValueID == 7 &&
                                x.id == checkSelectedValueID && (
                                  <Box className="addUserCont">
                                    <ValidationController
                                      name="selected_ids" // Field name for validation
                                      validationConfig={{
                                        validate: validateSelection,
                                      }}
                                      errors={errors}
                                      control={control}
                                      renderer={({ field }) => (
                                        <AddMultipleDepartments
                                          title="select_department"
                                          icon={<Plus />}
                                          selPlaceholder="select_department"
                                          mainParents={branchesDeps}
                                          setSelectedIds={(ids) => {
                                            field.onChange(ids);
                                            setSelectedIds(ids);
                                          }}
                                          selectedIds={selectedIds}
                                        />
                                      )}
                                    />
                                  </Box>
                                )}
                              {checkSelectedValueID == 8 &&
                                x.id == checkSelectedValueID && (
                                  <Box className="addUserCont">
                                    <ValidationController
                                      name="selected_ids"
                                      validationConfig={{
                                        validate: validateSelection,
                                      }}
                                      errors={errors}
                                      control={control}
                                      renderer={({ field }) => (
                                        // <AddMultipleUsers
                                        //   title="add_users"
                                        //   icon={<SingleProfile />}
                                        //   selPlaceholder="SelectUser"
                                        //   mainParents={usersList}
                                        //   setSelectedIds={(ids) => {
                                        //     field.onChange(ids);
                                        //     setSelectedIds(ids);
                                        //   }}
                                        // />
                                        <AddMultipleUsersBranchDep
                                          title="select_department"
                                          icon={<Plus />}
                                          selPlaceholder="SelectUser"
                                          // mainParents={branchesDeps}
                                          onClick={() => {
                                            setSelectedIds(null);
                                            resetField("selected_ids");
                                            setCheckedUsers(null);
                                          }}
                                          setSelectedIds={(ids) => {
                                            field.onChange(ids);
                                            setSelectedIds(ids);
                                          }}
                                          seValue={setValue}
                                          hqBranchesList={hqBranchesList}
                                          usersList={usersList}
                                          branchesDeps={branchesDeps}
                                          userSelections={userSelections}
                                          checkedUsers={checkedUsers}
                                          checkedHqBranches={checkedHqBranches}
                                          onFormChange={(ids) => {
                                            field.onChange(ids);
                                          }}
                                          setUserSelections={(selections) => {
                                            setUserSelections(selections);

                                            const userIds =
                                              selections.user_ids ?? [];

                                            if (userIds.length > 0) {
                                              field.onChange(userIds);
                                              setSelectedIds(userIds);
                                            } else {
                                              field.onChange([]);
                                              setSelectedIds([]);
                                            }
                                          }}
                                        />
                                      )}
                                    />
                                  </Box>
                                )}
                              {checkSelectedValueID == 9 &&
                                x.id == checkSelectedValueID && (
                                  <Box className="addUserCont">
                                    <ValidationController
                                      name="selected_ids"
                                      validationConfig={{
                                        validate: validateSelection,
                                      }}
                                      errors={errors}
                                      control={control}
                                      onClick={() => {
                                        setSelectedIds(null);
                                        resetField("selected_ids");
                                        setCheckedUsers(null);
                                      }}
                                      renderer={({ field }) => (
                                        // <AddMultipleUsers
                                        //   title="add_users"
                                        //   icon={<SingleProfile />}
                                        //   selPlaceholder="SelectUser"
                                        //   mainParents={usersList}
                                        //   setSelectedIds={(ids) => {
                                        //     field.onChange(ids);
                                        //     setSelectedIds(ids);
                                        //   }}
                                        // />
                                        <AddMultipleUsersBranchDep
                                          title="select_department"
                                          icon={<Plus />}
                                          selPlaceholder="SelectUser"
                                          // mainParents={branchesDeps}
                                          // setSelectedIds={(ids) => {
                                          //   field.onChange(ids);
                                          //   setSelectedIds(ids);
                                          // }}

                                          setSelectedIds={(ids) => {
                                            field.onChange(ids);
                                            setSelectedIds(ids);
                                          }}
                                          setValue={setValue}
                                          checkedUsers={checkedUsers}
                                          hqBranchesList={hqBranchesList}
                                          usersList={usersList}
                                          branchesDeps={branchesDeps}
                                          userSelections={userSelections}
                                          checkedHqBranches={checkedHqBranches}
                                          onFormChange={(ids) => {
                                            field.onChange(ids);
                                          }}
                                          setUserSelections={(selections) => {
                                            setUserSelections(selections);

                                            const userIds =
                                              selections.user_ids ?? [];

                                            if (userIds.length > 0) {
                                              field.onChange(userIds);
                                              setSelectedIds(userIds);
                                            } else {
                                              field.onChange([]);
                                              setSelectedIds([]);
                                            }
                                          }}
                                        />
                                      )}
                                    />
                                  </Box>
                                )}
                            </Box>
                          ))}
                          <Box className="px-4">
                            {errors.common_settings_id?.type === "required" && (
                              <ValidationErrorText
                                text={
                                  t(errors.common_settings_id?.message) ||
                                  t("Pleaseselectone")
                                }
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                      {/* Phase 4 */}
                      <Box className="optionsWrapper">
                        <Box className="optionsContent">
                          <SubHeadingStyled
                            size="15px"
                            weight={700}
                            color={"var(--text)"}
                            className="px-4 pt-4 pb-0"
                          >
                            {t("myself")}
                          </SubHeadingStyled>
                          {radioOptions?.slice(9)?.map((x, i) => (
                            <Box
                              key={i}
                              className={`w-100 p-2 ${
                                i !== radioOptions.length - 1 &&
                                "separation-border"
                              }`}
                            >
                              <FormRadio
                                name="common_settings_id"
                                label={t(x.title)}
                                // subLabel={t(x.description)}
                                value={x.id}
                                register={register}
                                checked={
                                  parseInt(checkSelectedValueID) == x?.id
                                }
                                validationRules={{
                                  required: true,
                                }}
                                onClick={() => {
                                  setSelectedIds(null);
                                  resetField("selected_ids");
                                }}
                              />
                            </Box>
                          ))}
                          <Box className="px-4">
                            {errors.common_settings_id?.type === "required" && (
                              <ValidationErrorText
                                text={
                                  t(errors.common_settings_id?.message) ||
                                  t("Pleaseselectone")
                                }
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box className="innerFoHead">
                        <SubHeadingStyled size="16px" color="var(--text)">
                          {t("Access_granted_through_request")}
                        </SubHeadingStyled>
                      </Box>
                      <FormElementWrapper className="d-flex gap-2">
                        {accessThroughRequest.length > 0 &&
                          accessThroughRequest.map((item, i) => (
                            <UserUpload>
                              <Box className="userPlaceholder">
                                <img
                                  src={item?.profile || PlaceholderImg}
                                  alt="user"
                                />
                              </Box>
                              <Box className="abtUser">
                                <SpanStyled color="var(--text)" size="14px">
                                  {item?.from_user?.name}
                                </SpanStyled>
                              </Box>
                              <MenuTriggerCross
                                className="removeTaskTrigger"
                                onClick={() => handleRemoveRequest(item?.id)}
                              />
                            </UserUpload>
                          ))}
                      </FormElementWrapper>
                    </>
                  )}
                  <Box className="d-flex justify-content-end">
                    <Box className="p-4 d-flex gap-3">
                      <ButtonStyled
                        label={t("Cancel")}
                        bg={"var(--bgSecondary)"}
                        color={"var(--text2)"}
                        type="button"
                        onClick={() => navigate(`/temporary-cabinets/${id}/temporary-files`)}
                      />
                      <ButtonStyled
                        label={t("Update")}
                        type="submit"
                        isLoading={submitLoading}
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </ContentWrapper>
        )}
      </Form>
    </ProfileWrapper>
  );
};

export default EditTemporaryFile;

const UserUpload = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  padding: 8px 16px;
  background-color: var(--bgSecondary);
  border-radius: 10px;
  width: fit-content;
  .userPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    background-color: var(--greyBg);
    border-radius: 50%;
    // border: 1px dashed var(--greyText);
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  svg.removeTaskTrigger {
    width: 12px;
    height: 12px;
    margin-left: 7px;
    &:hover {
      stroke: var(--redColor);
      fill: var(--redColor);
      path {
        stroke: var(--redColor);
        fill: var(--redColor);
      }
    }
  }
  input[type="file"] {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .abtUser {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    span {
      // width: 100%;
    }
  }
`;
